<template>

  <v-menu v-model="menuVisible" :close-on-content-click="false" transition="slide-y-transition" max-width="300"
    content-class="statustag-menu" offset-y>

    <template v-slot:activator="{ props }">
      <div class="d-flex w-100">
        <statustag class="my-auto chip-w-100 cursor-pointer w-100" full_with :statuses="statuses" :type="type"
          :selected="selected" :size="size" v-bind="props">
        </statustag>

        <v-chip v-if="close_btn" class="ml-1 text-center one-click-close-btn" :size="size"
          @click="update(ticketSettings.status_closed)" label color="green"><v-icon size="14">fal
            fa-check</v-icon></v-chip>
      </div>
    </template>

    <v-list density="compact" nav>
      <v-list-item v-for="status in statuses" :key="status.id" @click="update(status.id)"
        class="px-1 py-0 cursor-pointer">
        <statustag class="my-auto chip-w-100" :statuses="statuses" :size="size" full_with :type="type"
          :selected="status.id">
        </statustag>
      </v-list-item>
    </v-list>
  </v-menu>


</template>

<script>
import { useMainStore } from "@/stores/store";


export default {
  name: "StatusChipMenu",
  props: {
    statuses: { type: Array, required: true },
    type: { type: String, default: "chip" },
    selected: { type: Number, required: true },
    full_with: { type: Boolean, default: false },
    size: { type: String, default: "large" },
    ticket_id: { type: Number, default: null },
    close_btn: { type: Boolean, default: false },
  },

  data: () => ({
    menuVisible: false,
    closed_status: null,
  }),
  methods: {
    update(statusId) {
      console.log(statusId);
      if (this.ticket_id) {
        this.$emit('update:value', { statusId, ticketId: this.ticket_id });
      } else {
        this.$emit('update:value', statusId);
      }
      this.menuVisible = false;
    },



  },
  computed: {
    ticketSettings() {
      const store = useMainStore();
      return store.getTicketSettings;


    },

    // Get the selected status object from statuses array
    selectedStatus() {
      if (!this.selected) return;
      return this.statuses.find(status => status.id === this.selected);
    },
    // Get color from selected status
    computedStatusColor() {
      return this.selectedStatus ? this.selectedStatus.color : "#ccc";
    },
  },
};
</script>

<style>
.statustag-menu {
  .one-click-close-btn {
    opacity: 0;
  }

  &:hover {
    .one-click-close-btn {
      opacity: 1;
    }
  }
}
</style>